module.exports = __webpack_public_path__ + "static/chart-1_animation-3480d31f548e4a035531b751aa603a6f.mp4";